import { render, staticRenderFns } from "./PhysicalPersonCreate.vue?vue&type=template&id=1ccf6cca&scoped=true"
import script from "./PhysicalPersonCreate.vue?vue&type=script&lang=js"
export * from "./PhysicalPersonCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccf6cca",
  null
  
)

export default component.exports